import React, { Fragment, useEffect, useState } from 'react';
import moment from 'moment';
import { AbortableNavigateEvent } from '@philips-internal/oswald-ui-core/lib/component/types/navigable.js';
import { createAbort, isFunction } from '@philips-internal/oswald-ui-utils';
import { getWeekDaysRange } from '../date-picker-util.js';
import { DatePickerContent } from './date-picker-content.js';
import { DatePickerTimeSpan } from './date-picker-time-span.js';
function getInitialWeekDaysByMonth(date) {
    const dateClone = date.clone();
    return getWeekDaysRange(dateClone.startOf('month'));
}
function getInitialWeekDaysByWeek(date) {
    const dateClone = date.clone();
    return getWeekDaysRange(dateClone.startOf('week'));
}
function DatePickerWeekContent(props) {
    const [weekDaysRange, setWeekDaysRange] = useState([]);
    const [rangeData, setRangeData] = useState([]);
    const [innerValue, setInnerValue] = useState(undefined);
    const { currentDate, data, date, enabled, isModalWrapped, loading, mode, monthDate, onCellClick, onTitleClick, rangeEnabled, ranges, showNavigationArrows, value, } = props;
    useEffect(() => {
        const baseDate = date ?? moment();
        const today = moment().startOf('day');
        let range = weekDaysRange;
        // date-picker-week-mode mapps the date-picker value,
        // so we can work on the data when value changes.
        // verify if value is present - date is selected
        if (value && value.isSame(monthDate, 'month')) {
            // if internal value was mapped - check for value change
            if (!innerValue || !innerValue.isSame(value)) {
                range = getInitialWeekDaysByWeek(value);
                setInnerValue(value);
            }
        }
        // if no range is present, component should map range based on current month
        if (!range.length) {
            range = today.isSame(monthDate, 'month') ? getInitialWeekDaysByWeek(today) : getInitialWeekDaysByMonth(baseDate);
        }
        setWeekDaysRange(range);
        filterWeekData(range);
    }, [value, date, data, innerValue]);
    const filterWeekData = (weekDays) => {
        const { data } = props;
        const currentWeek = [];
        if (!data || !data.length) {
            return;
        }
        data.forEach((week) => week.forEach((day) => {
            if (!day.date) {
                return;
            }
            const weekDay = (weekDays || weekDaysRange).find((weekDay) => day.date.isSame(weekDay, 'day'));
            if (weekDay) {
                currentWeek.push(day);
            }
        }));
        setRangeData([currentWeek]);
    };
    const getWeek = (initialDate) => {
        return Array(7).fill(null).map((_, index) => initialDate.clone().add(index, 'days'));
    };
    function onNavigate(delta) {
        const { date, onArrowClick, onNavigate } = props;
        let weekDays;
        if (delta === 1) {
            const firstDayNextWeek = weekDaysRange[0].clone().add(7, 'days');
            weekDays = getWeek(firstDayNextWeek);
        }
        else {
            const firstDayPreviousWeek = weekDaysRange[0].clone().subtract(7, 'days');
            weekDays = getWeek(firstDayPreviousWeek);
        }
        const abort = createAbort();
        const firstDay = weekDays[0];
        const lastDay = weekDays[6];
        if (isFunction(onNavigate)) {
            onNavigate(new AbortableNavigateEvent({ abort, from: firstDay.toString() ?? date.toString(), to: lastDay.toString() }));
        }
        void abort.promise.then(aborted => {
            if (aborted) {
                return;
            }
            const isCurrentMonth = delta === 1 ? lastDay.isSame(date, 'month') : firstDay.isSame(date, 'month');
            setWeekDaysRange(weekDays);
            filterWeekData(weekDays);
            if (!isCurrentMonth) {
                onArrowClick(delta);
            }
        });
    }
    return (React.createElement(Fragment, null,
        React.createElement(DatePickerTimeSpan, { date: date ?? moment(), enableNext: enabled, enablePrev: enabled, mode: mode, onArrowClick: onNavigate, onTitleClick: onTitleClick, showNavigationArrows: showNavigationArrows }),
        React.createElement(DatePickerContent, { currentDate: currentDate, data: rangeData, enabled: enabled, isModalWrapped: isModalWrapped, loading: loading, mode: mode, monthDate: monthDate, onArrowClick: onNavigate, onClick: onCellClick, rangeEnabled: rangeEnabled, ranges: ranges })));
}
export { DatePickerWeekContent, };
//# sourceMappingURL=date-picker-week-content.js.map